<form [formGroup]="form" autocomplete="off" class="form-horizontal">

    <common-ui-personenstamm-daten
      [affectNavigationInfo]=affectNavigationInfo
      [(data)]="data"
      [readonly]="readonly">
    </common-ui-personenstamm-daten>

    <div class="form-row">
        <label class="col-sm-4 col-form-label"
               for="geburtsname{{index}}">{{ 'COMMON_UI.PERSON.GEBURTSNAME' | translate }}</label>
        <div class="col-sm-8">
            <input
                    type="text"
                    id="geburtsname{{index}}"
                    class="form-control" datevMessagePath="geburtsname{{objectId}}"
                    formControlName="geburtsname"
                    utilsCheckValidity utilsControlState utilsValidationMessage/>
        </div>
    </div>

    <div class="form-row">
        <label class="col-sm-4 col-form-label"
               for="geburtsdatum{{index}}">{{ 'COMMON_UI.PERSON.GEBURTSDATUM' | translate }}</label>
        <div class="col-sm-8">
            <date-picker
                    id="geburtsdatum{{index}}"
                    messagePath="geburtsdatum{{objectId}}"
                    formControlName="geburtsdatum"
                    [isRequired]=true>
            </date-picker>
        </div>
    </div>

    <div class="form-row">
        <label class="col-sm-4 col-form-label"
               for="religionsschluessel{{index}}">{{ 'COMMON_UI.PERSON.RELIGIONSSCHLUESSEL.LABEL' | translate }}</label>
        <div class="col-sm-8">
            <select class="form-control" datevMessagePath="religionsschluessel{{objectId}}"
                    formControlName="religionsschluessel"
                    id="religionsschluessel{{index}}" utilsCheckValidity utilsControlState
                    utilsMarkRequired
                    utilsValidationMessage>
                <option [ngValue]="null" disabled hidden
                        selected>{{ 'COMMON_UI.PERSON.RELIGIONSSCHLUESSEL.NULL' | translate }}</option>
                <option *ngFor="let value of enumKeys(religionsschluesselEnum)"
                        [ngValue]="religionsschluesselEnum[value]">
                    {{ 'COMMON_UI.PERSON.RELIGIONSSCHLUESSEL.KEY_' + religionsschluesselEnum[value] | translate }}
                </option>
            </select>
        </div>
    </div>

    <div class="form-row">
        <label class="col-sm-4 col-form-label"
               for="beruf{{index}}">{{ 'COMMON_UI.PERSON.BERUF' | translate }}</label>
        <div class="col-sm-8">
            <input class="form-control" datevMessagePath="beruf{{objectId}}" formControlName="beruf" id="beruf{{index}}"
                   type="text" utilsCheckValidity utilsControlState utilsValidationMessage/>
        </div>
    </div>

</form>
